<template>
  <div id="login">
    <body class="login-page err-500">
        <div class="container">
        <loading :active.sync="isLoading" 
                  :can-cancel="true" 
                  :is-full-page="fullPage"></loading>
            <div class="login-container">
                <div class="row">
                    <div class="col-lg-4 col-md-5 col-sm-9 lfh">
                        <div class="card login-box">
                            <div class="card-body">
                                <h5 class="card-title">Forgot Password</h5>
                                <form v-on:submit.prevent="onSubmit" method="POST" action="#" @keyup.enter="sendemail(e)">
                                 <p style="color:red;text-align:center">{{ errorMessage ? errorMessage : ''  }}</p>
                                 <p v-if="errors.length">
                                  <p style='color:red;text-align:center' v-for="error in errors"> {{ error }}</p>
                                  </p>
                                    <div class="form-group">
                                      <!-- <input type="email" class="form-control" name="email" id="email" ref="email" v-model="input.email"  placeholder="Enter email" tabindex="1"> -->
                                    <input type="email" class="form-control" name="email" ref="email" v-model="input.email"  id="exampleInputEmail" aria-describedby="emailHelp" placeholder="Enter email" tabindex="1" spellcheck="false" autofocus />
                                    </div>
                                    <button type="button" class="btn btn-primary m-l-xxs float-right" v-on:click="sendemail(e)">Forgot Password</button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </body>
  </div>
</template>
<script>
  import axios from 'axios'
  import Loading from 'vue-loading-overlay'
  import 'vue-loading-overlay/dist/vue-loading.css'
  export default {
    name: 'Forgotpassword',
    components: {
       Loading
     },
    data () {
      return {
        isLoading: false,
        fullPage: true,
        errors: [],
        errorMessage: '',
        input: {
          email: ''
        }
      }
    },
    methods: {
      sendemail (e) {
        this.errors = []
        var jwttoken = localStorage.getItem('jwt')
        var x = this.input.email
         var atposition = x.indexOf('@')
         var dotposition = x.lastIndexOf('.')
         if (this.input.email === '') {
           this.errors.push('Email is Required')
           this.$refs.email.focus()
           this.errorMessage = ''
         } else if (atposition < 1 || dotposition < atposition + 2 || dotposition + 2 >= x.length) {
           this.errors.push('Please enter a valid e-mail address123 ')
           this.$refs.email.focus()
           this.errorMessage = ''
         } else {
           var email = this.input.email
           this.isLoading = true
           axios.post('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/forgotPassword',
             {
               email: email
             },{
              headers: {
                'x-access-token': jwttoken
              }})
             .then(response => {
               this.errorMessage = response.data.message
               this.isLoading = false
               
             })
             .catch((error) => {
                 this.errorMessage = error.response.data.errors
                 this.isLoading = false
              
             })
         } 
       }
    },
    mounted () {
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Forgotpassword.vue